export default {"src":"/_next/static/media/LOGOWhite.88e8652b.svg","height":36,"width":199,"blurWidth":0,"blurHeight":0};